import { useContext } from "react";
import { NotificationContext } from "../context/NotificationsContext";

export const useNotificationsContext = () => useContext(NotificationContext);
